module.exports = __webpack_public_path__ + "img/18-1 iPhone dual SIM.67bad510.png";